import type { PublishingOptionType } from '@ContractBuilder/types';
import type { BrandingStatus } from '@domain/schemas/branding.schema';

import { ALLOWED_STATUSES, brandingPublishingOptions } from '../constants';

export const getPublishingOptions = (currentStatus?: BrandingStatus): PublishingOptionType[] =>
  currentStatus
    ? brandingPublishingOptions.filter(({ id: status }) => ALLOWED_STATUSES[currentStatus].includes(status as any))
    : brandingPublishingOptions;
